<template>
  <div class="toasts" aria-live="polite">
    <transition-group name="toast">
      <div v-for="t in toasts" :key="t.id" class="toast" :class="t.type">{{ t.text }}</div>
    </transition-group>
  </div>
</template>

<script>
import { toastState } from '@/utils/toast'

export default {
  name: 'ToastHost',
  computed: {
    toasts () { return toastState.list }
  }
}
</script>

<style scoped>
.toasts {
  position: fixed; top: 84px; left: 50%; transform: translateX(-50%);
  z-index: 200; display: flex; flex-direction: column; gap: 8px; align-items: center;
  pointer-events: none;
}
.toast {
  padding: 10px 18px; border-radius: var(--radius-sm);
  background: var(--panel); border: 1px solid var(--border-strong);
  color: var(--text-strong); font-size: 14px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);
}
.toast.success { border-color: rgba(16, 185, 129, 0.5); color: var(--green); }
.toast.error { border-color: rgba(255, 59, 48, 0.5); color: #FF8A84; }
.toast-enter-active, .toast-leave-active { transition: all 0.25s; }
.toast-enter, .toast-leave-to { opacity: 0; transform: translateY(-8px); }
</style>
